import { colors } from '../../assets/styles/styleguide'
import { bool, func } from 'prop-types'
import styled from 'styled-components'

const StyledBurger = styled.button<{ open: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 1.5rem;
    height: 1.5rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 99;

    &:focus {
        outline: none;
    }

    div {
        width: 1.5rem;
        height: 0.2rem;
        background: ${colors.primary};
        border-radius: 10px;
        transition: all 0.3s linear;
        position: relative;
        transform-origin: 1px;

        :first-child {
            transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
        }

        :nth-child(2) {
            opacity: ${({ open }) => (open ? '0' : '1')};
            transform: ${({ open }) =>
                open ? 'translateX(20px)' : 'translateX(0)'};
        }

        :nth-child(3) {
            transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
        }
    }
`

interface Props {
    open: any
    setOpen: any
}

const Burger = ({ open, setOpen }: Props) => {
    return (
        <StyledBurger
            open={open}
            onClick={(e) => {
                e.stopPropagation()
                setOpen(!open)
            }}
        >
            <div />
            <div />
            <div />
        </StyledBurger>
    )
}

Burger.propTypes = {
    open: bool.isRequired,
    setOpen: func.isRequired,
}

export default Burger
